import LegacyBookmark from './LegacyBookmark';

export * from './LegacyBookmark';

export default LegacyBookmark;
